"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTAGAnalyticsProvider = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var GTAGAnalyticsProvider = (function () {
    function GTAGAnalyticsProvider() {
    }
    GTAGAnalyticsProvider.prototype.track = function (name, value, params) {
        if (process.env.NODE_ENV === "development") {
            gtag && gtag("event", name, tslib_1.__assign({ debug_mode: true }, params));
        }
        else {
            gtag && gtag("event", name, params);
        }
    };
    GTAGAnalyticsProvider = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], GTAGAnalyticsProvider);
    return GTAGAnalyticsProvider;
}());
exports.GTAGAnalyticsProvider = GTAGAnalyticsProvider;
//# sourceMappingURL=GTAGAnalyticsProvider.js.map